import { useState } from 'react';
import { WelcomeOfferCard } from './welcomeOfferCard';
import { TWelcomeOffer } from '../../cms';
import { TEST_ID } from '../../utils/constants';
import { Slider } from '../carousel-slider/slider';
import Consent from '../consent.tsx';

export const WelcomeOffersList = ({
  welcomeOffers,
  handleOnKeyDown,
  handleSelect,
}: {
  welcomeOffers?: TWelcomeOffer[];
  handleOnKeyDown: (event: React.KeyboardEvent<HTMLDivElement>) => void;
  handleSelect: (offerId: string) => void;
}) => {
  const [hovered, setHovered] = useState(false);
  const onMouseEnter = () => {
    setHovered(true);
  };

  const onMouseLeave = () => {
    setHovered(false);
  };

  return (
    <div
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className='-mx-sm tablet:-mx-12'
      data-testid={TEST_ID.PREFIX + 'welcome-offer-list'}
    >
      <Slider hovered={hovered}
        bottomContent={
          welcomeOffers?.map((offer) => (
            <Consent
              key={offer.name}
              widgetTitle={offer.widgetTitle}
              {...offer.consent}
            />
          ))
        }>
        {welcomeOffers?.map((offer) => (
          <WelcomeOfferCard
            key={offer.name}
            welcomeOffer={offer}
            handleOnKeyDown={handleOnKeyDown}
            handleSelect={handleSelect}
          />
        ))}
      </Slider>
    </div>
  );
};
